/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import { useEffect, useState } from "react";
import { getArreglo } from "../../services/GestionAtencionService";
import { DataGrid } from "@mui/x-data-grid";
import { gcConfirmaAProduccion } from "../../services/GestionAtencionService";
import WaitingDialog from "../../utils/WaitingDialog";
//
// ###########################################################################
//
const ArregloEstadoDialog = ({ onClose, idGestionAtencionArreglo, setMessage, setShowMessage }) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [arreglo, setArreglo] = useState({});
  const [arregloFornituraRows, setArregloFornituraRows] = useState([]);
  const [arregloServicioRows, setArregloServicioRows] = useState([]);
  const [arregloTratamientoRows, setArregloTratamientoRows] = useState([]);
  const [arregloEstadoRows, setArregloEstadoRows] = useState([]);
  const [openDialogConfirmaProduccion, setOpenDialogConfirmaProduccion] = useState(false);

  const tableColumnsFornitura = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableColumnsServicio = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableColumnsTratamiento = [
    {
      field: "ojo",
      headerName: "Ojo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tiempo_produccion",
      headerName: "Tiempo de Producción",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tiempo_produccion ? params.row.tiempo_produccion + " DÍAS" : "";
        return _val;
      },
    },
  ];

  const tableColumnsEstado = [
    {
      field: "descripcion_corta_area",
      headerName: "Área",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado_short",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado_short;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "accion_short",
      headerName: "Acción",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.accion_short;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cambio_articulo",
      headerName: "Cambio",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cambio_articulo ? "CAMBIO" : "";
        return _val;
      },
    },
    {
      field: "detalle",
      headerName: "Detalle",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.detalle;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "observaciones",
      headerName: "Observaciones",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.observaciones;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "usuario_username",
      headerName: "Vend/Oper",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario_username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadArreglo = async () => {
      setIsDoingSomething(true);
      const response = await getArreglo(idGestionAtencionArreglo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _arregloObject = response.data.data.arreglo;

        _arregloObject = {
          ..._arregloObject,
          armazonAsol:
            _arregloObject.codigo_articulo +
            " - " +
            _arregloObject.descripcion_articulo +
            " - " +
            _arregloObject.descripcion_ar_as_marca +
            " - " +
            _arregloObject.modelo_articulo,
          nombreApellidoCliente:
            _arregloObject.nombre_cliente + " " + _arregloObject.apellido_cliente,
          telefonosCliente:
            _arregloObject.telefono_movil_cliente + " " + _arregloObject.telefono_cliente,
          fechaNacimientoClienteEdad:
            _arregloObject.fecha_nac_cliente + " - " + _arregloObject.edad_cliente + " años",
        };

        setArreglo(_arregloObject);

        let _arregloFornituraList = response.data.data.arreglo.gc_arreglo_fornitura_list.map((item) => {
          return {
            ...item,
            id: item.id_gc_arreglo_fornitura,
          };
        });
        let _arregloServicioList = response.data.data.arreglo.gc_arreglo_servicio_list.map((item) => {
          return {
            ...item,
            id: item.id_gc_arreglo_servicio,
          };
        });
        let _arregloTratamientoList = response.data.data.arreglo.gc_arreglo_tratamiento_list.map((item) => {
          return {
            ...item,
            id: item.id_gc_arreglo_tratamiento,
          };
        });

        setArregloFornituraRows(_arregloFornituraList);
        setArregloServicioRows(_arregloServicioList);
        setArregloTratamientoRows(_arregloTratamientoList);
        let _arregloEstadoRows = response.data.data.gc_anteojo_arreglo_estado_list;
        setArregloEstadoRows(_arregloEstadoRows.filter((item) => item.accion_code !== "asigna-bandeja" && item.accion_code !== "libera-bandeja"));
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadArreglo();
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleCloseDialogConfirmaProduccion = (parConfirmaProduccion) => {
    parConfirmaProduccion =
      typeof parConfirmaProduccion == "boolean" ? parConfirmaProduccion : false;

    if (parConfirmaProduccion) {
      confirmaAProduccion(idGestionAtencionArreglo);
    }

    setOpenDialogConfirmaProduccion(false);
  };
  //
  // ################################################################################
  //
  const confirmaAProduccion = async (paridGestionAtencionArreglo) => {
    setIsDoingSomething(true);
    const response = await gcConfirmaAProduccion("", "", paridGestionAtencionArreglo);
    setIsDoingSomething(false);

    if (response.ok) {
      onClose();
    }

    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth={false}
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Arreglo {arreglo.codigo_gc_arreglo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Cliente
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="nombreApellidoCliente"
                  label="Nombre y Apellido"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="nombreApellidoCliente"
                  value={arreglo.nombreApellidoCliente ? arreglo.nombreApellidoCliente : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="fechaNacimientoClienteEdad"
                  label="Fecha de nacimiento - Edad"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="fechaNacimientoClienteEdad"
                  value={
                    arreglo.fechaNacimientoClienteEdad ? arreglo.fechaNacimientoClienteEdad : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="email"
                  label="email"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="email_cliente"
                  value={arreglo.email_cliente ? arreglo.email_cliente : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="telefonosCliente"
                  label="Teléfonos"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="telefonosCliente"
                  value={arreglo.telefonosCliente ? arreglo.telefonosCliente : ""}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Anteojo y Cristales del Cliente
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="descripcion_anteojo_cristales"
                  label="Anteojo y Cristales del Cliente"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="descripcion_anteojo_cristales"
                  value={
                    arreglo.descripcion_anteojo_cristales
                      ? arreglo.descripcion_anteojo_cristales
                      : ""
                  }
                  variant="outlined"
                  multiline
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Armazón / Anteojo de Sol
                </Typography>
              </Grid>
            </Grid>

            {arreglo.montura_nuevo_cliente === "nuevo" && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="armazonAsol"
                  label="Código - Descripción - Marca - Modelo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="armazonAsol"
                  value={arreglo.armazonAsol}
                />
              </Grid>
            )}

            {arreglo.montura_nuevo_cliente === "cliente" && (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    id="estado_montura"
                    label="Estado de la montura"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="estado_montura"
                    value={arreglo.estado_montura}
                  />
                </Grid>
              </Grid>
            )}
          </Box>

          {arregloServicioRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Servicios
              </Typography>
              <DataGrid
                rows={arregloServicioRows}
                columns={tableColumnsServicio}
                {...tableOptions}
              />
            </Box>
          )}

          {arregloTratamientoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Tratamientos
              </Typography>
              <DataGrid
                rows={arregloTratamientoRows}
                columns={tableColumnsTratamiento}
                {...tableOptions}
              />
            </Box>
          )}

          {arregloFornituraRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Fornituras
              </Typography>
              <DataGrid
                rows={arregloFornituraRows}
                columns={tableColumnsFornitura}
                {...tableOptions}
              />
            </Box>
          )}

          {arreglo.observaciones_gc_arreglo && (
            <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Notas y observaciones
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="observaciones_gc_arreglo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="observaciones_gc_arreglo"
                  value={arreglo.observaciones_gc_arreglo}
                  multiline
                />
              </Grid>
            </Box>
          )}

          {arregloEstadoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Estados del Arreglo
              </Typography>
              <DataGrid
                rows={arregloEstadoRows}
                columns={tableColumnsEstado}
                {...tableOptions}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            {arreglo.action_confirmar_para_produccion && (
              <Button
                sx={{ mr: 1, backgroundColor: "warning" }}
                variant="contained"
                onClick={() => {
                  setOpenDialogConfirmaProduccion(true);
                }}
                startIcon={<PrecisionManufacturingOutlinedIcon />}
              >
                Confirmar para producción
              </Button>
            )}

            {arreglo.action_no_confirmar_para_produccion && (
              <Button
                sx={{ mr: 1, backgroundColor: "warning" }}
                variant="contained"
                // onClick={setOpenDialogNoConfirmaProduccion(true)}
                startIcon={<PrecisionManufacturingOutlinedIcon />}
              >
                No confirmar para producción
              </Button>
            )}
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* >>>> confirmation production dialog */}

      <Dialog
        open={openDialogConfirmaProduccion}
        onClose={handleCloseDialogConfirmaProduccion}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmación a Producción"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Estás seguro que querés confirmar el envío a producción de este Arreglo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialogConfirmaProduccion(true)}>
            Confirmar a Producción
          </Button>
          <Button onClick={() => handleCloseDialogConfirmaProduccion(false)} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ArregloEstadoDialog;
